import React, { useState } from "react";
import { Search, ShieldCheck, AlertTriangle, Settings, Globe, Check } from "lucide-react";

export default function ReconCard({ subdomains, techStack, waf }) {
  const [showAllSubs, setShowAllSubs] = useState(false);
  const hasSubs = subdomains && subdomains.subdomains && subdomains.subdomains.length > 0;
  const hasTech = techStack && techStack.technologies && techStack.technologies.length > 0;
  const hasWaf = waf && waf.wafs && waf.wafs.length > 0;

  if (!hasSubs && !hasTech && !hasWaf) return null;

  const subsToShow = hasSubs ? (showAllSubs ? subdomains.subdomains : subdomains.subdomains.slice(0, 10)) : [];

  return (
    <div className="au-glass au-pad" style={{ marginBottom: 20 }}>
      <div className="au-eyebrow" style={{
        display: "flex", alignItems: "center", gap: 8,
        marginBottom: 18,
        paddingBottom: 14, borderBottom: "1px solid var(--au-hair)"
      }}>
        <Search size={14} aria-hidden="true" /> RECONNAISSANCE &amp; INTELLIGENCE
      </div>

      {hasWaf && (
        <Section icon={ShieldCheck} title="PERIMETER DEFENSE (WAF)" count={waf.count}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {waf.wafs.map((w, i) => (
              <span key={i} className="au-chip au-chip-status" style={{ color: "var(--au-success)" }}>
                <Check size={12} aria-hidden="true" /> {w}
              </span>
            ))}
          </div>
        </Section>
      )}

      {!hasWaf && waf && (
        <Section icon={ShieldCheck} title="PERIMETER DEFENSE (WAF)" count={0}>
          <div style={{
            color: "var(--au-warn)", fontSize: 12, padding: "8px 12px",
            display: "flex", alignItems: "center", gap: 8,
            background: "var(--au-glass)", borderRadius: "var(--au-r-sm)",
            border: "1px solid var(--au-hair)"
          }}>
            <AlertTriangle size={14} aria-hidden="true" /> No WAF detected — target exposed to direct attacks
          </div>
        </Section>
      )}

      {hasTech && (
        <Section icon={Settings} title="DETECTED TECHNOLOGY STACK" count={techStack.count}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {techStack.technologies.map((t, i) => (
              <span key={i} className="au-chip au-chip-status" style={{ color: "var(--au-accent-ink)" }}>
                <span style={{ fontWeight: 600 }}>{t.name}</span>
                <span style={{ color: "var(--au-muted)", marginLeft: 6, fontSize: 10 }}>
                  · {t.category}
                </span>
              </span>
            ))}
          </div>
        </Section>
      )}

      {hasSubs && (
        <Section icon={Globe} title="ATTACK SURFACE — SUBDOMAINS" count={subdomains.count}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 6 }}>
            {subsToShow.map((s, i) => (
              <div key={i} className="au-mono" style={{
                fontSize: 12, color: "var(--au-text-2)",
                padding: "6px 10px",
                background: "var(--au-glass)",
                borderRadius: "var(--au-r-input)",
                borderLeft: "2px solid var(--au-accent)",
                wordBreak: "break-all"
              }}>{s}</div>
            ))}
          </div>
          {subdomains.subdomains.length > 10 && (
            <button onClick={() => setShowAllSubs(!showAllSubs)} className="au-pill au-pill-glass au-pill-sm" style={{
              marginTop: 12
            }}>
              {showAllSubs ? "Show Less" : `Show All ${subdomains.subdomains.length} →`}
            </button>
          )}

        </Section>
      )}
    </div>
  );
}

function Section({ icon: Icon, title, count, children }) {
  return (
    <div style={{ marginBottom: 22 }}>
      <div style={{
        display: "flex", justifyContent: "space-between",
        alignItems: "center", marginBottom: 12
      }}>
        <div style={{
          fontSize: 11, color: "var(--au-text-2)", letterSpacing: 1.5, fontWeight: 700,
          display: "inline-flex", alignItems: "center", gap: 8, textTransform: "uppercase"
        }}>
          {Icon && <Icon size={14} aria-hidden="true" />} {title}
        </div>
        <span className="au-chip au-chip-status" style={{ color: "var(--au-accent-ink)" }}>{count} found</span>
      </div>
      {children}
    </div>
  );
}
